import { DeleteOutline } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Switch, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import Camera from "../../assets/svg/Camera.svg";
import PenForEdit from "../../assets/svg/PenForEdit.svg";
import DeleteModal from "../../components/Modals/DeleteModal";
import {
  GET_ALL_DOOR_STEP_CATEGORIES,
  UPDATE_DOOR_STEP_CATEGORIES,
} from "../../URLs/Apis";
import "./Services.css";

function Services() {
  const { user } = useSelector((state) => state.auth);

  const [show, setShow] = useState(false);

  const typesToShow = [
    {
      label: "Card",
      value: "Card",
    },
    {
      label: "Dropdown",
      value: "Dropdown",
    },
    {
      label: "Checkbox",
      value: "Checkbox",
    },
    {
      label: "Radio",
      value: "Radio",
    },
  ];

  const handleShow = () => {
    setAddMainCatigory({
      icon_url: "",
      fileUrl: "",
      name: "",
      description: "",
      order: "",
      status: "",
      slug: "",
      background_color: "",
      show_as: "",
    });
    setImages([]);
    setIsEditing(false);
    setEditCategoryId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const [images, setImages] = useState([]);

  const [removedImages, setRemovedImages] = useState([]);

  const [addMainCatigory, setAddMainCatigory] = useState({
    icon_url: "",
    description: "",
    name: "",
    order: "",
    status: "",
    slug: "",
    background_color: "",
    show_as: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  const [editCategoryId, setEditCategoryId] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditCategoryId(null);
    handleClose();
  };

  const confirmDelete = () => {
    setShowDelete(true);
  };

  const navigate = useNavigate();

  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  const [mainCategotiesData, setMainCategotiesData] = useState([]);

  useEffect(() => {
    getStaffData();
  }, []);

  const [checked_AddOrder, setChecked_AddOrder] = useState([]);

  const handleEditCategory = (category) => {
    console.log(category);
    const baseURL = "https://estbn.com/EstbnNew/public";
    const fullImageUrl = category.icon_url.startsWith("http")
      ? category.icon_url
      : `${baseURL}${category.icon_url}`;

    const existingImages =
      category.images?.map((img) => ({
        id: img.id,
        preview: img.image_url.startsWith("http")
          ? img.image_url
          : `${baseURL}${img.image_url}`,
        file: null,
        isFromBackend: true,
      })) || [];

    setImages(existingImages);

    setAddMainCatigory({
      icon_url: "",
      fileUrl: fullImageUrl,
      name: category.name,
      description: category.description,
      order: category.order,
      status: category.status,
      slug: category.slug,
      background_color: category.background_color,
      show_as: category.show_as,
    });
    setValue("name", category.name);
    setValue("description", category.description);
    setValue("order", category.order);
    setValue("status", category.status);
    setValue("slug", category.slug);
    setValue("background_color", category.background_color);
    setValue("show_as", category.show_as);
    setIsEditing(true);
    setEditCategoryId(category.id);
    setShow(true);
  };

  const handleChange_AddOrder = (id) => {
    const isActive = checked_AddOrder.includes(id);
    const newStatus = isActive ? "inactive" : "active";

    axios
      .post(
        `https://estbn.com/EstbnNew/public/api/service_categories/${id}`,
        { status: newStatus },
        { headers }
      )
      .then(() => {
        setChecked_AddOrder((prev) =>
          isActive ? prev.filter((item) => item !== id) : [...prev, id]
        );
      })
      .catch((err) => {
        console.error("Update failed:", err);
      });
  };

  const getStaffData = () => {
    axios
      .get(GET_ALL_DOOR_STEP_CATEGORIES, { headers })
      .then((res) => {
        const categories = res.data.data.categories || [];
        console.log(res.data.data.categories);
        setMainCategotiesData(categories);

        const activeIds = categories
          .filter((e) => e.status === "active")
          .map((e) => e.id);

        setChecked_AddOrder(activeIds);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };

  const onSubmitAddMainCatogiry = () => {
    const headers = {
      Authorization: "Bearer " + user?.token,
    };

    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    if (!isEditing) {
      if (addMainCatigory.icon_url) {
        formData.append("icon_url", addMainCatigory.icon_url);
      } else {
        toast.error("Please upload a valid image for the icon.");
        return;
      }
    } else {
      if (addMainCatigory.icon_url instanceof File) {
        formData.append("icon_url", addMainCatigory.icon_url);
      }
    }

    formData.append("name", addMainCatigory.name || "");
    formData.append("description", addMainCatigory.description || "");
    formData.append("order", addMainCatigory.order || "");
    formData.append("status", addMainCatigory.status || "");
    formData.append("slug", addMainCatigory.slug || "");
    formData.append("background_color", addMainCatigory.background_color || "");
    formData.append("show_as", addMainCatigory.show_as || "");

    const existingCount = images.filter((img) => img.isFromBackend).length;

    const newImages = images.filter((img) => !img.isFromBackend && img.file);

    newImages.forEach((img, i) => {
      const idx = existingCount + i;
      formData.append(`images[${idx}][image]`, img.file);
    });

    removedImages.forEach((id) => {
      formData.append("remove_images[]", String(id));
    });

    const url = isEditing
      ? `${UPDATE_DOOR_STEP_CATEGORIES}${editCategoryId}`
      : "https://estbn.com/EstbnNew/public/api/portal/doorstep-service-categories";

    axios
      .post(url, formData, { headers })
      .then((response) => {
        toast.success(response.data.message || "Saved");
        setShow(false);
        getStaffData();
        setImages([]);
        setRemovedImages([]);
        setAddMainCatigory({
          icon_url: "",
          description: "",
          name: "",
          order: "",
          status: "",
          slug: "",
          background_color: "",
          show_as: "",
        });
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || error.message || "Error");
        console.log(error.response?.data || error);
      });
  };

  const deleteSubCategory = async () => {
    try {
      let response = await axios.delete(
        `${UPDATE_DOOR_STEP_CATEGORIES}${editCategoryId}`,
        {
          headers,
        }
      );
      toast.warning("Category Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getStaffData();
    } catch (error) {
      toast.error("Failed To Delete This Category.");
      console.log(error.message);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm();

  return (
    <>
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this category?"}
        deleteFunction={deleteSubCategory}
      />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="AddStaffModal_title d-flex justify-content-between align-items-center w-100">
            {isEditing ? "Edit Main Category" : "Add New Main Category"}
            {isEditing ? (
              <DeleteOutline
                onClick={() => confirmDelete()}
                style={{ color: "red", cursor: "pointer" }}
              />
            ) : (
              ""
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                {...register("icon_url")}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/gif",
                      "image/svg+xml",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddMainCatigory({
                        ...addMainCatigory,
                        icon_url: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error(
                        "Please select a valid image file (jpeg, png, jpg, gif, svg)."
                      );
                      setAddMainCatigory({
                        ...addMainCatigory,
                        icon_url: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="addstaff_photo">
                {addMainCatigory.fileUrl ? (
                  <img
                    className="photoStyle_addMember"
                    src={addMainCatigory.fileUrl}
                    alt="Selected"
                  />
                ) : (
                  <img src={AddPhoto} alt="Default" />
                )}
                <div className="AddStaff_cameraIcon">
                  <img src={Camera} alt="" />
                </div>
              </label>
              {addMainCatigory.fileUrl && (
                <div style={{ marginTop: 20 }}>
                  <p>Selected Photo: {addMainCatigory.fileUrl}</p>{" "}
                </div>
              )}
              {errors.icon_url && (
                <p className="danger">{errors.icon_url.message}</p>
              )}
            </div>
            {/* name & background  */}
            <div className="row">
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Category Name"
                  variant="outlined"
                  {...register("name")}
                  value={addMainCatigory.name}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      name: e.target.value,
                    });
                  }}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Category Background"
                  variant="outlined"
                  {...register("background_color")}
                  value={addMainCatigory.background_color}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      background_color: e.target.value,
                    });
                  }}
                />
                {errors.background_color && (
                  <p className="danger">{errors.background_color.message}</p>
                )}
              </div>
            </div>
            {/* order & status */}
            <div className="row">
              <div className="col-6">
                <TextField
                  type="number"
                  className="w-100 mb-4"
                  label="Order Number"
                  variant="outlined"
                  {...register("order")}
                  value={addMainCatigory.order}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      order: e.target.value,
                    });
                  }}
                />
                {errors.order && (
                  <p className="danger">{errors.order.message}</p>
                )}
              </div>
              <div className="col-6">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addMainCatigory.status}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        status: e.target.value,
                      });
                    }}
                  >
                    <MenuItem className="custom-menu-item" value="active">
                      Active
                    </MenuItem>
                    <MenuItem className="custom-menu-item" value="inactive">
                      Inactive
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* slug & type */}
            <div className="row">
              {/* slug */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Slug"
                  variant="outlined"
                  {...register("slug")}
                  value={addMainCatigory.slug}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      slug: e.target.value,
                    });
                  }}
                />
                {errors.slug && <p className="danger">{errors.slug.message}</p>}
              </div>
              {/* type */}
              <div className="col-6">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="Show-As">Show As</InputLabel>
                  <Select
                    labelId="Show-As"
                    label="Show As"
                    {...register("show_as")}
                    value={addMainCatigory.show_as}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        show_as: e.target.value,
                      });
                    }}
                  >
                    {typesToShow.map((ty) => (
                      <MenuItem className="custom-menu-item" value={ty.value}>
                        {ty.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.show_as && (
                  <p className="danger">{errors.show_as.message}</p>
                )}
              </div>
            </div>
            {/* description  */}
            <TextField
              className="w-100 mb-4"
              label="Category Description"
              variant="outlined"
              rows={4}
              multiline
              {...register("description")}
              value={addMainCatigory.description}
              onChange={(e) => {
                setAddMainCatigory({
                  ...addMainCatigory,
                  description: e.target.value,
                });
              }}
            />
            {errors.description && (
              <p className="danger">{errors.description.message}</p>
            )}
            {/* Multiple Images Upload Section */}
            <div className="mb-4">
              <div className=" d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold">Attachments</label>
                <input
                  type="file"
                  id="galleryImages"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files);
                    const validFiles = selectedFiles.filter((file) =>
                      [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "image/gif",
                        "image/svg+xml",
                      ].includes(file.type)
                    );

                    if (validFiles.length !== selectedFiles.length) {
                      toast.error(
                        "Some files were skipped (invalid image types)"
                      );
                    }

                    const newImages = validFiles.map((file) => ({
                      file,
                      preview: URL.createObjectURL(file),
                      isFromBackend: false,
                    }));

                    setImages((prev) => [...prev, ...newImages]);
                  }}
                />
                <label
                  htmlFor="galleryImages"
                  className="btn btn-light d-flex align-items-center gap-2"
                >
                  <i className="bi bi-upload" style={{ fontSize: "1rem" }}></i>
                  Add Images
                </label>
              </div>
              <div className="d-flex justify-content-evenly align-items-center flex-wrap gap-2 mt-3">
                {images.map((img, index) => (
                  <div
                    key={index}
                    className="position-relative d-flex justify-content-center align-items-center my-1"
                    style={{
                      width: "22%",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      height: "100px",
                    }}
                  >
                    <img
                      src={img.preview}
                      alt={`preview-${index}`}
                      style={{
                        width: "90%",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setImages((prev) => prev.filter((_, i) => i !== index));
                        if (img.isFromBackend && img.id) {
                          setRemovedImages((prev) => [...prev, img.id]);
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "22px",
                        height: "22px",
                        cursor: "pointer",
                        paddingBottom: "4px",
                      }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* footer  */}
            <div className="foterAddModel">
              <button
                type="button"
                className="closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="titleOfServicesPage m-4">
        <p className="my-sm-2 fs-5 my-md-0 fw-bold fs-4">Doorstep</p>
        <div
          className="staff-header_edete-icon mainBorder d-flex "
          onClick={handleShow}
        >
          <AddIcon />
          <span className="ms-1 d-flex">Add Category</span>
        </div>
      </div>
      <div className="mainCategoryCards m-4">
        {mainCategotiesData.map((cat) => {
          return (
            <>
              <div
                key={cat.id}
                className="services_card cursorPointer"
                style={{
                  backgroundColor: `${cat.background_color}`,
                }}
                onClick={() => {
                  navigate("/services/" + cat.id);
                }}
              >
                <div className="edateArea_mainCategory">
                  <FormControlLabel
                    key={cat.id}
                    control={
                      <Switch
                        checked={checked_AddOrder.includes(cat.id)}
                        onChange={() => handleChange_AddOrder(cat.id)}
                        onClick={(e) => e.stopPropagation()}
                        sx={{ m: 1 }}
                      />
                    }
                    label=""
                  />
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditCategory(cat);
                    }}
                    className="penIconEdate"
                  >
                    <img src={PenForEdit} alt="Pen Icon" />
                  </div>
                </div>
                <div className="mainCategory_img ">
                  <img
                    src={
                      cat?.icon_url?.startsWith("http")
                        ? cat.icon_url
                        : `https://estbn.com/EstbnNew/public${cat.icon_url}`
                    }
                    alt={cat.slug}
                  />
                </div>
                <div className="mianCategory_title">{cat.name}</div>
                <div className="mianCategory_descrebtion">
                  {cat.description}
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}

export default Services;
